<script lang="ts">
	export let fill = "#a5c1f9";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 35 35">
	<g>
		<g>
			<path
				d="M131.972 278.024a17.5 17.5 0 1 0 17.5 17.5 17.5 17.5 0 0 0-17.5-17.5zm0 33.6a16.1 16.1 0 1 1 16.1-16.1 16.12 16.12 0 0 1-16.1 16.1z"
				transform="translate(-114.472 -278.024)"
				fill={fill} />
		</g>
		<g>
			<g>
				<path
					d="M123.969 303.437a.7.7 0 0 1 0-1.407l21.4-.03a.7.7 0 0 1 0 1.407l-21.4.03z"
					transform="translate(-117.17 -285.22)"
					fill={fill} />
			</g>
			<g>
				<path
					d="M139.183 309.622a.7.7 0 0 1-.7-.7l-.03-21.4a.7.7 0 0 1 .7-.7.7.7 0 0 1 .7.7l.03 21.4a.7.7 0 0 1-.7.705z"
					transform="translate(-121.669 -280.721)"
					fill={fill} />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
</style>
